var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M959 363L959 391",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 959.5,
    cy: 358.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M956.105 367C955.637 367 955.236 366.834 954.903 366.501C954.57 366.168 954.403 365.768 954.403 365.3C954.403 364.833 954.57 364.432 954.903 364.099C955.236 363.766 955.637 363.6 956.105 363.6C956.573 363.6 956.973 363.766 957.306 364.099C957.64 364.432 957.806 364.833 957.806 365.3C957.806 365.768 957.64 366.168 957.306 366.501C956.973 366.834 956.573 367 956.105 367ZM964.613 367C964.145 367 963.744 366.834 963.411 366.501C963.078 366.168 962.911 365.768 962.911 365.3C962.911 364.833 963.078 364.432 963.411 364.099C963.744 363.766 964.145 363.6 964.613 363.6C965.081 363.6 965.481 363.766 965.814 364.099C966.148 364.432 966.314 364.833 966.314 365.3C966.314 365.768 966.148 366.168 965.814 366.501C965.481 366.834 965.081 367 964.613 367ZM955.382 353.4L957.423 357.65H963.379L965.719 353.4H955.382ZM954.573 351.7H967.122C967.449 351.7 967.697 351.845 967.867 352.136C968.037 352.426 968.044 352.72 967.888 353.018L964.868 358.457C964.712 358.741 964.503 358.96 964.24 359.116C963.978 359.272 963.691 359.35 963.379 359.35H957.041L956.105 361.05H966.314V362.75H956.105C955.467 362.75 954.985 362.47 954.658 361.911C954.332 361.351 954.318 360.795 954.616 360.242L955.764 358.16L952.702 351.7H951V350H953.765L954.573 351.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.401ad204a8c8bae4a26df32fb8e750ff.svg";
export { ForwardRef as ReactComponent };